import React, { Component } from 'react';

import { Link } from 'react-router';

import { ListItem } from 'material-ui/List';
import ContextIconMenu from '../Common/ContextIconMenu';
import IconButton from 'material-ui/IconButton';
import InfoIcon from 'material-ui/svg-icons/action/info';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import EventIcon from 'material-ui/svg-icons/action/event';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

import { colors as Colors } from 'material-ui/styles';
import { statusColours } from '../../constants/ColourConstants';

import VenueIcon from 'material-ui/svg-icons/communication/location-on';
import VenueActions from '../../actions/VenueActionCreator';

import ROLES from '../../constants/Roles';

const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    menuItem: {
        color: '#CC0000',
    },
    iconButton: {
        marginRight: 0,
    },
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};


class VenueListItem extends Component {

    render() {

        const row = this.props.data;
        const infoLink = `/dashboard/venue/${row.id}`;
        const editLink = `/dashboard/venue/${row.id}/edit`;
        const settingsLink = `/dashboard/venue/${row.id}/settings`;

        const actions = [
            {
                link: infoLink,
                label: 'Preview',
                icon: <InfoIcon />
            },
            {
                link: `/dashboard/venue/${row.id}/events`,
                label: 'Calendar',
                icon: <EventIcon />
            },
            {
                type:'divider'
            },
            {
                link: settingsLink,
                label: 'Settings',
                icon: <SettingsIcon />,
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                link: editLink,
                label: 'Edit',
                icon: <EditIcon />,
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: row.id,
                title: 'Delete venue',
                deleteAction: VenueActions.delete,
                message: (
                            <span>
                                Are you sure to delete the venue  "{row.name}" ?
                            </span>
                        ),
                condition: {
                    show:  row.sysStatus > 4,
                    roles: [ROLES.ADMIN]
                }
            }
        ];

        let statusLine  = '-';

        if (!!row.capacity) {
            statusLine  = `capacity ${row.capacity}`;
        }

        return (

            <ListItem
                style={style.listItem}
                leftAvatar={
                    <Link to={infoLink}>
                        <VenueIcon
                         style={style.icon}
                         color={row.status !== 'unavailable' ? statusColours.primary : statusColours.disabled}
                        />
                    </Link>
                }
                primaryText={
                    <Link to={infoLink} className="primaryText">
                    {row.name}
                    </Link>
                }
                secondaryText={
                    <Link to={infoLink} className="secondaryText">
                        {row.description}<br />
                        {statusLine}
                    </Link>
                }
                secondaryTextLines={2}
                rightIcon={
                    <ContextIconMenu
                        actions={actions}
                        data={row}
                        menuStyle={style.menu}
                        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                        targetOrigin={{horizontal: 'right', vertical: 'top'}}
                        iconButtonElement={
                            <IconButton
                                touch={true}
                                style={style.iconButton}
                            >
                                <MoreVertIcon  color={Colors.grey400} />
                            </IconButton>
                        }
                    />
                }

            />
        )
    }
}

export default VenueListItem;
